import { useRouter } from 'vue-router';
import { useStore } from './store.service';
import { api } from './api.service';
import { UserResponse, ConfigResponse } from '../types/api.types';
import { useNotifications } from './notifications.service';

export function useAuthService() {
  const store = useStore();
  const router = useRouter();
  const { showSuccess } = useNotifications();

  const config = async () => {
    try {
      const response = await api.get<ConfigResponse>('/config');
      if (!response?.success) {
        return false;
      }

      store.setConfig(response?.data);
      return true;
    } catch (error: unknown) {
      return false;
    }
  }

  const user = async () => {
    try {
      store.setData('isLoading', true);
      const response = await api.get<UserResponse>('/auth/user');
      
      if (!response || !response?.data?.user) {
        throw new Error('Failed to fetch user data');
      }

      store.setAuthenticated(true);
      store.setData('user', response.data.user);
    } catch (error) {
      store.setAuthenticated(false);
      store.clearData('user');
    } finally {
      store.setData('isLoading', false);
    }
  }

  const logout = () => {
    // Clear authentication data from store
    store.setAuthenticated(false);
    store.clearData('user');

    // Clear all tokens (access and refresh) from local storage
    api.clearBothTokens();

    showSuccess('Logout successful!');

    // Redirect to specified page
    router.push('/');
  };


  return {
    config,
    user,
    logout,
  };
}
